import { render, staticRenderFns } from "./limitReward.vue?vue&type=template&id=6b43f3e5&scoped=true&"
import script from "./limitReward.vue?vue&type=script&lang=js&"
export * from "./limitReward.vue?vue&type=script&lang=js&"
import style0 from "./limitReward.vue?vue&type=style&index=0&id=6b43f3e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b43f3e5",
  null
  
)

export default component.exports